module.exports = __webpack_public_path__ + "img/phone-hangup.4e2a96cc.svg";